import { useContext, createContext } from 'react';
import { type CanonicalTheme } from '@/theme/theme-utils';

export interface ThemeContextProps {
  // Applied theme resolved for the DOM (never 'device')
  theme: CanonicalTheme;
  // Stored user preference (may be 'device')
  preference: CanonicalTheme;
  toggleTheme: () => void;
  setTheme: (theme: CanonicalTheme) => void;
  setTemporaryTheme: (theme: CanonicalTheme) => void;
  clearTemporaryTheme: () => void;
  isTemporaryTheme: boolean;
}

export const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);

export const useTheme = (): ThemeContextProps => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
